module.exports = __webpack_public_path__ + "media/form/icon_error-8d15862c.svg";